export const BANNER_NAME = 'COOKIE_CONSENT_BANNER';

export const BANNER_HEIGHT = 74;
export const MIN_BANNER_WIDTH = 320;
